import heroBlock from './hero-block';
import videoBlock from './video-block';
import guides from './guides';
import tools from './tools';
import helpLines from './helplines';
import updates from './updates';
import cookies from './cookies';
import notFound from './not-found';
import searchResults from './search-results';
import footer from './footer';
import header from './header';
import breadcrumbs from './breadcrumbs';
import seoPageTitleList from './seo/title';
import seoPageDescriptionList from './seo/description';
import navigation from './navigation';

export default {
    heroBlock,
    videoBlock,
    guides,
    tools,
    helpLines,
    updates,
    cookies,
    notFound,
    searchResults,
    footer,
    header,
    breadcrumbs,
    seoPageTitleList,
    seoPageDescriptionList,
    navigation,
};
